'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { Spinner } from '../spinner/spinner';
import { IconButtonRootContext } from './context/icon-button-root.context';
import { iconButtonLoadingStyles } from './styles/icon-button-loading.styles';
import type { IconButtonLoadingPropsInterface } from './types/icon-button-loading.types';

/**
 * @since 10.6.0
 */
export const IconButtonLoading = forwardRef<HTMLSpanElement, IconButtonLoadingPropsInterface>(
  (props, forwardedRef) => {
    const context = useContext(IconButtonRootContext);
    const {
      tone = context.tone || 'neutral',
      emphasis = context.emphasis || 'outlined',
      onImpact = context.onImpact || false,
      size = context.size || 'md',
    } = props;
    const styles = css(iconButtonLoadingStyles);

    const isInverted = onImpact
      ? emphasis !== 'filled'
      : (tone === 'brand' || tone === 'critical') && emphasis === 'filled';

    const isFixedMode = tone === 'neutral-fixed';

    const spinnerSize = size === 'xs' || size === 'sm' ? 'sm' : 'md';

    return (
      <span
        ref={forwardedRef}
        data-c11n-component="IconButton.Loading"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'group', styles)}
      >
        <Spinner size={spinnerSize} onImpact={isInverted} fixedMode={isFixedMode} />
      </span>
    );
  },
);

IconButtonLoading.displayName = 'IconButton.Loading';
